import React from 'react'

import { GETTING_STARTED_STEP_TITLES } from '@/components/flows/CompleteRegistrationFlow/constants'
import CompanyServices from '@/components/flows/CompleteRegistrationFlow/steps/1_CompanyServices/CompanyServices'
import ActionButton from '@/components/misc/ActionButton'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import LoadingWidget from '@/components/widgets/LoadingWidget'
import {
  useCurrentCompanyServicesQuery,
  useInvalidateCurrentCompanyServicesQuery,
} from '@/hooks/useCompanyServicesQuery'
import useNotyf from '@/hooks/useNotyf'
import { useRefreshSessionMetadataMutation } from '@/hooks/useRefreshSessionMetadataMutation'

const SelectServicesModal: React.FC = () => {
  const notyf = useNotyf()
  const companyServicesQuery = useCurrentCompanyServicesQuery()
  const refreshSessionMetadataMutation = useRefreshSessionMetadataMutation()
  const invalidateCurrentCompanyServicesQuery =
    useInvalidateCurrentCompanyServicesQuery()

  const companyServices = companyServicesQuery.data?.['hydra:member'] || []
  const cannotDismissModal = companyServices.length < 2

  async function hideModal() {
    await refreshSessionMetadataMutation.mutateAsync()
    notyf.success("Thank you for selecting your company's services")
  }

  const isProcessing = refreshSessionMetadataMutation.isPending

  return (
    <Dialog open>
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>
            {GETTING_STARTED_STEP_TITLES['company-services']}
          </DialogTitle>
        </DialogHeader>

        <DialogBody>
          {companyServicesQuery.isPending ? (
            <LoadingWidget />
          ) : (
            <CompanyServices
              onUpdate={() => invalidateCurrentCompanyServicesQuery()}
            />
          )}
        </DialogBody>

        <DialogFooter>
          <Tooltip>
            <TooltipTrigger>
              <span>
                <ActionButton
                  variant="success"
                  size="lg"
                  onClick={hideModal}
                  isProcessing={isProcessing}
                  disabled={cannotDismissModal || isProcessing}
                >
                  Done
                </ActionButton>
              </span>
            </TooltipTrigger>

            {cannotDismissModal && (
              <TooltipContent>
                Please select at least 2 services to continue
              </TooltipContent>
            )}
          </Tooltip>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default SelectServicesModal
